import { kill } from "process";
import { getBasePath } from "@/lib/utils";

export const routes = {
  root: "/",
  admin: "admin",
  salesOps: "sales-ops",
  crm_head: "crm-head",
  finance_team: "finance",
  lab_team_head: "labs-head",
  inventory_team: "inventory-team",
  lab_team: "lab-team",
  region_head: "region-head",
  relationship_manager: "relationship-manager",
  login: "login",
  changePassword: "change-password",
  forgotPassword: "forgot-password",
  add: "add",
  edit: "edit",
  view: "view",
  id: ":id",
  action: ":action",
  dashboard: "dashboard",
  masterData: "master-data",
  employee: "employee",
  task: "task",
  geoRegion: "geo-region",
  invoice_code: "invoice-code",
  taskCategory: "task-category",
  taskTerm: "task-term",
  submodule: "submodule",
  inventory: "inventory",
  tlmMaster: "tlm-master",
  curriculum: "curriculum",
  kit: "kit",
  predefinedTask: "predefined-task",
  taskAssignment: "task-assignment",
  schoolTaskAssignment: "school-task-assignment",
  school: "school",
  myTask: "my-task",
  report: "report"
};

/**
 * Get the school redirect path based on user's persona/role
 * @param userRole - User's role(s) from Redux state (loggedInUserData.role)
 * @returns The school path for the user's persona
 */
export const getSchoolRedirectPath = (userRole: string[] | string | undefined): string => {
  const basePath = getBasePath(userRole);
  return `/${basePath}/${routes.school}`;
};

// Legacy export for backward compatibility - will be removed after migration
export const redirectRoutes = {
  school: `/${routes.salesOps}/${routes.school}`,
};
